import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "amount" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "amount-title" }
const _hoisted_4 = { class: "amount-main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, key, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "block"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t(key)), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", {
              class: _normalizeClass([
              'quantity',
              { customersAmount: key === 'customersAmount' },
              { satisfiedCustomersAmount: key === 'satisfiedCustomersAmount' },
              key === 'generalSatisfaction'
                ? _ctx.getGeneralSatisfactionClass(item.quantity)
                : ''
            ])
            }, _toDisplayString(item.quantity), 3),
            _createElementVNode("div", {
              class: _normalizeClass(["comparison", _ctx.getComparisonClass(item.comparison)])
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.getComparison(item.comparison)), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('compareTo')), 1)
            ], 2)
          ])
        ]))
      }), 128))
    ])
  ]))
}